import React from 'react'
import '../Cardpage.css'
import petfood from '../Images/petfoods.jpg'
function PremiumPet() {
  return (
    <>
    <div className='cardpagediv'>
      <h3 className='cardpagehead'>Premium Pet Foods</h3>
      <img src={petfood} className='w-100 imgbanner' height={400} alt="" />
    </div>
    <p className='cardpagepara1 ms-2 me-2'>
      All premium pet foods for Dogs, Cats, Birds are available at our Store.
       We always satisfy our customers with the high quality products and maximum discounts for them.
       We are also concerned about your pets and so maintain a good quality for the products.
    </p>
    <h5 className='cardpagehead5'>
      Premium Brands of pet Foods we have:
    </h5>
    <ul>
      <li>Royal Canine</li>
      <li>N & D</li>
      <li>Drools</li>
      <li>Iams</li>
      <li>Meo</li>
      <li>Pedigree</li>
      <li>Bonacibo</li>
      <li>Wiskas</li>
      <li>Purepet</li>
    </ul>
    <p className='ms-2 pagebott'>We will provide any  Pet food based on your pet's requirements. </p>
    </>

  )
}

export default PremiumPet